import React from 'react';
import { promoBanners } from '../data';

export default function PromoBanners() {
  return (
    <section style={{ marginTop: '2rem' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
          {promoBanners.map((b, i) => (
            <div key={i}
              style={{ backgroundImage: `url(${b.bg})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '12px', padding: '2.5rem 2rem', minHeight: 180, position: 'relative', overflow: 'hidden' }}
            >
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.55)', borderRadius: 12 }} />
              <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div>
                  <h2 style={{ fontWeight: 700, fontSize: '1.125rem', color: '#111827' }}>{b.title}</h2>
                  <p style={{ color: '#374151', fontSize: '0.875rem' }}>Get Upto <strong>{b.offer}</strong> Off</p>
                </div>
                {/* <a href="#!" style={{ display: 'inline-flex', alignItems: 'center', padding: '8px 18px', background: '#1f2937', color: 'white', borderRadius: '8px', fontSize: '0.8125rem', fontWeight: 600, textDecoration: 'none', width: 'fit-content' }}>Shop Now</a> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
